module.exports = __webpack_public_path__ + "d6ed97904b810d211cd1dd9570fb2e2c.svg";